import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageNotFoundComponent } from 'src/app/layout/pages/page-not-found/page-not-found.component';
import { EditInvoiceComponent } from './edit-invoice/edit-invoice.component';
import { EmailInvoiceComponent } from './email-invoice/email-invoice.component';
import { InvoicesSmartComponent } from './invoices-smart.component';

import {NewInvoiceComponent} from './new-Invoice/new-invoice.component'
import { PreviewInvoiceComponent } from './preview-invoice/preview-invoice.component';

export const invoicesRoutes: Routes = [
    {
        path: 'addinvoice', component: NewInvoiceComponent
     },
     {
       path: 'edit-invoice', component: EditInvoiceComponent
     },
    {
      path: 'edit-invoice/:id', component: EditInvoiceComponent
    },
    {
      path: 'invoice-preview/:id', component: PreviewInvoiceComponent
    },
     {
       path: 'invoice-preview', component: PreviewInvoiceComponent
     }, 
    {
      path: 'email-preview/:id', component: EmailInvoiceComponent
    },
    {
      path: '', component: InvoicesSmartComponent,
    },
    {
        path: '**', component: PageNotFoundComponent
  }];

@NgModule({
  imports: [RouterModule.forChild(invoicesRoutes)],
  exports: [RouterModule]
})
export class InvoicesRoutingModule { }
